// Curated country list for the checkout dropdown, grouped by shipping region.
// The backend `_get_shipping_rate` accepts any string and falls back to
// "Rest of World" for anything unrecognised, so this list is presentation-only.
// UK is placed first (default destination). Order within each group is
// alphabetical for scannability.

export const COUNTRY_GROUPS = [
  {
    label: 'United Kingdom',
    countries: ['United Kingdom'],
  },
  {
    label: 'Europe',
    countries: [
      'Austria',
      'Belgium',
      'Bulgaria',
      'Croatia',
      'Cyprus',
      'Czech Republic',
      'Denmark',
      'Estonia',
      'Finland',
      'France',
      'Germany',
      'Greece',
      'Hungary',
      'Iceland',
      'Ireland',
      'Italy',
      'Latvia',
      'Liechtenstein',
      'Lithuania',
      'Luxembourg',
      'Malta',
      'Netherlands',
      'Norway',
      'Poland',
      'Portugal',
      'Romania',
      'Slovakia',
      'Slovenia',
      'Spain',
      'Sweden',
      'Switzerland',
      'Turkey',
    ],
  },
  {
    label: 'United States',
    countries: ['United States'],
  },
  {
    label: 'Rest of world',
    countries: [
      'Argentina',
      'Australia',
      'Bahrain',
      'Brazil',
      'Canada',
      'Chile',
      'China',
      'Colombia',
      'Egypt',
      'Ghana',
      'Hong Kong',
      'India',
      'Indonesia',
      'Israel',
      'Japan',
      'Jordan',
      'Kenya',
      'Kuwait',
      'Malaysia',
      'Mexico',
      'Morocco',
      'New Zealand',
      'Nigeria',
      'Oman',
      'Pakistan',
      'Peru',
      'Philippines',
      'Qatar',
      'Saudi Arabia',
      'Singapore',
      'South Africa',
      'South Korea',
      'Sri Lanka',
      'Taiwan',
      'Thailand',
      'Ukraine',
      'United Arab Emirates',
      'Uruguay',
      'Vietnam',
    ],
  },
];

// Flat list for consumers that just need to check membership.
export const COUNTRY_LIST = COUNTRY_GROUPS.flatMap((g) => g.countries);
